/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11 6L9 12H13L11 18M20 9L20.6431 9.25724C21.7646 9.70586 22.5 10.7921 22.5 12C22.5 13.208 21.7646 14.2942 20.643 14.7428L20 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 5H6.5V5C6.03566 5 5.80349 5 5.60793 5.01926C3.70882 5.20631 2.20631 6.70882 2.01926 8.60793C2 8.80349 2 9.03566 2 9.5V14.5C2 14.9643 2 15.1965 2.01926 15.3921C2.20631 17.2912 3.70882 18.7937 5.60793 18.9807C5.80349 19 6.03566 19 6.5 19V19H7M15 5H15.5V5C15.9643 5 16.1965 5 16.3921 5.01926C18.2912 5.20631 19.7937 6.70882 19.9807 8.60793C20 8.80349 20 9.03566 20 9.5V15V15C20 17.2091 18.2091 19 16 19H15.5H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 11.4C2 9.15979 2 8.03969 2.43597 7.18404C2.81947 6.43139 3.43139 5.81947 4.18404 5.43597C5.03969 5 6.15979 5 8.4 5H13.6C15.8402 5 16.9603 5 17.816 5.43597C18.5686 5.81947 19.1805 6.43139 19.564 7.18404C20 8.03969 20 9.15979 20 11.4V12.6C20 14.8402 20 15.9603 19.564 16.816C19.1805 17.5686 18.5686 18.1805 17.816 18.564C16.9603 19 15.8402 19 13.6 19H8.4C6.15979 19 5.03969 19 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.816C2 15.9603 2 14.8402 2 12.6V11.4Z"
				fill="currentColor"
			/>
			<path
				d="M7 5H6.5V5C6.03566 5 5.80349 5 5.60793 5.01926C3.70882 5.20631 2.20631 6.70882 2.01926 8.60793C2 8.80349 2 9.03566 2 9.5V14.5C2 14.9643 2 15.1965 2.01926 15.3921C2.20631 17.2912 3.70882 18.7937 5.60793 18.9807C5.80349 19 6.03566 19 6.5 19V19H7M15 5H15.5V5C15.9643 5 16.1965 5 16.3921 5.01926C18.2912 5.20631 19.7937 6.70882 19.9807 8.60793C20 8.80349 20 9.03566 20 9.5V15M20 15V15C20 17.2091 18.2091 19 16 19H15.5H15M20 15L20.643 14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9M11 6L9 12H13L11 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.43404 19.314C4.28968 19.75 5.40979 19.75 7.65 19.75L14.35 19.75C16.5902 19.75 17.7103 19.75 18.566 19.314C19.3186 18.9305 19.9305 18.3186 20.314 17.566C20.6013 17.0021 20.6993 16.3234 20.7327 15.2849L20.7828 15.2706C22.2431 14.8534 23.2499 13.5187 23.2499 12C23.2499 10.4813 22.2431 9.14661 20.7829 8.72939L20.7327 8.71505C20.6993 7.67662 20.6013 6.99791 20.314 6.43404C19.9305 5.68139 19.3186 5.06947 18.566 4.68598C17.7103 4.25 16.5902 4.25 14.35 4.25L7.65 4.25C5.40979 4.25 4.28968 4.25 3.43404 4.68598C2.68139 5.06947 2.06947 5.68139 1.68597 6.43404C1.25 7.28969 1.25 8.40979 1.25 10.65L1.25 13.35C1.25 15.5902 1.25 16.7103 1.68597 17.566C2.06947 18.3186 2.68139 18.9305 3.43404 19.314ZM20.7499 10.3257C20.75 10.4311 20.75 10.5392 20.75 10.65L20.75 13.35C20.75 13.4608 20.75 13.5689 20.7499 13.6743C21.3563 13.348 21.7499 12.7099 21.7499 12C21.7499 11.29 21.3563 10.6519 20.7499 10.3257ZM7.78127 12.7996C7.94265 12.9231 8.23961 12.9231 8.83353 12.9231L9.23975 12.9231C9.57579 12.9231 9.7438 12.9231 9.87215 12.9885C9.98505 13.046 10.0768 13.1378 10.1344 13.2507C10.1998 13.379 10.1998 13.547 10.1998 13.8831L10.1998 14.9305C10.1998 15.8578 10.1998 16.3214 10.3651 16.4952C10.508 16.6454 10.7183 16.7111 10.9213 16.6691C11.1562 16.6206 11.4203 16.2396 11.9487 15.4775L11.9487 15.4775L13.9549 12.5839C14.2933 12.0958 14.4625 11.8518 14.453 11.6488C14.4447 11.472 14.3588 11.3079 14.2182 11.2004C14.0569 11.0769 13.7599 11.0769 13.166 11.0769L12.7598 11.0769C12.4237 11.0769 12.2557 11.0769 12.1274 11.0115C12.0145 10.954 11.9227 10.8622 11.8652 10.7493C11.7998 10.621 11.7998 10.453 11.7998 10.1169L11.7998 9.06948L11.7998 9.06947C11.7998 8.1422 11.7998 7.67857 11.6344 7.50481C11.4915 7.35465 11.2812 7.28888 11.0782 7.33086C10.8433 7.37944 10.5792 7.76046 10.0508 8.52249L8.0446 11.4161C7.7062 11.9042 7.537 12.1482 7.54652 12.3512C7.55481 12.528 7.64072 12.6921 7.78127 12.7996Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 5H6.5V5C6.03567 5 5.8035 5 5.60793 5.01926C3.70883 5.20631 2.20631 6.70882 2.01926 8.60793C2 8.80349 2 9.03566 2 9.5V10V10.5M15 5H15.5V5C15.9643 5 16.1965 5 16.3921 5.01926C18.2912 5.20631 19.7937 6.70882 19.9807 8.60793C20 8.80349 20 9.03566 20 9.5V15M20 15V15C20 17.2091 18.2091 19 16 19H15.5H15M20 15L20.643 14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9M7 19H6.5H6C6 19 6 19 6 19C3.79086 19 2 17.2091 2 15C2 15 2 15 2 15V15V14.5M11 6L9 12H13L11 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 5H6.5V5C6.03566 5 5.80349 5 5.60793 5.01926C3.70882 5.20631 2.20631 6.70882 2.01926 8.60793C2 8.80349 2 9.03566 2 9.5V14.5C2 14.9643 2 15.1965 2.01926 15.3921C2.20631 17.2912 3.70882 18.7937 5.60793 18.9807C5.80349 19 6.03566 19 6.5 19V19H7M15 5H15.5V5C15.9643 5 16.1965 5 16.3921 5.01926C18.2912 5.20631 19.7937 6.70882 19.9807 8.60793C20 8.80349 20 9.03566 20 9.5V15M20 15V15C20 17.2091 18.2091 19 16 19H15.5H15M20 15L20.643 14.7428C21.7646 14.2942 22.5 13.208 22.5 12C22.5 10.7921 21.7646 9.70586 20.6431 9.25724L20 9M11 6L9 12H13L11 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.65012 19.75C5.40991 19.75 4.28981 19.75 3.43416 19.314C2.68151 18.9305 2.06959 18.3186 1.6861 17.566C1.25012 16.7103 1.25012 15.5902 1.25012 13.35L1.25012 10.65C1.25012 8.40979 1.25012 7.28969 1.6861 6.43404C2.06959 5.68139 2.68151 5.06947 3.43416 4.68597C4.28981 4.25 5.40991 4.25 7.65012 4.25L14.3501 4.25C16.5903 4.25 17.7104 4.25 18.5661 4.68597C19.3187 5.06947 19.9307 5.68139 20.3141 6.43404C20.7501 7.28969 20.7501 8.40979 20.7501 10.65V13.35C20.7501 15.5902 20.7501 16.7103 20.3141 17.566C19.9307 18.3186 19.3187 18.9305 18.5661 19.314C17.7104 19.75 16.5903 19.75 14.3501 19.75H7.65012Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.0511 8.52244L8.04484 11.416C7.70644 11.9041 7.53725 12.1482 7.54677 12.3511C7.55506 12.5279 7.64096 12.692 7.78151 12.7995C7.9429 12.923 8.23986 12.923 8.83377 12.923L9.24 12.923C9.57603 12.923 9.74405 12.923 9.87239 12.9884C9.98529 13.0459 10.0771 13.1377 10.1346 13.2506C10.2 13.379 10.2 13.547 10.2 13.883L10.2 14.9305C10.2 15.8577 10.2 16.3214 10.3653 16.4951C10.5082 16.6453 10.7185 16.7111 10.9215 16.6691C11.1564 16.6205 11.4206 16.2395 11.9489 15.4775L13.9552 12.5839L13.9552 12.5839L13.9552 12.5838C14.2936 12.0958 14.4628 11.8517 14.4532 11.6488C14.4449 11.472 14.359 11.3079 14.2185 11.2004C14.0571 11.0769 13.7601 11.0769 13.1662 11.0769L12.76 11.0769C12.424 11.0769 12.256 11.0769 12.1276 11.0115C12.0147 10.954 11.9229 10.8622 11.8654 10.7493C11.8 10.6209 11.8 10.4529 11.8 10.1169L11.8 9.06943C11.8 8.14215 11.8 7.67851 11.6347 7.50476C11.4918 7.35459 11.2815 7.28882 11.0785 7.33081C10.8436 7.37939 10.5794 7.7604 10.0511 8.52243L10.0511 8.52243L10.0511 8.52244ZM23 11.9419L23 12.25C23 13.4927 21.9926 14.5 20.75 14.5L20.75 9.69191C21.9926 9.69191 23 10.6993 23 11.9419Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
